var _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGuestInfoReset(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1036_9200)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.25,
    y: 2.25,
    width: 29.5,
    height: 29.5,
    rx: 3.75,
    stroke: "#FFDC8A",
    strokeWidth: 0.5,
    shapeRendering: "crispEdges"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.9999 17.0774C28.9699 22.5778 24.4817 27.0228 18.9824 26.9999C13.4303 26.9753 8.95976 22.4705 9.00027 16.9419C9.04079 11.4591 13.5572 6.98246 19.0282 7.00005C24.5539 7.01764 29.0298 11.5418 28.9999 17.0774ZM21.1173 17.0721C22.109 18.1152 22.9475 18.9982 23.8529 19.9498C24.7583 18.9929 25.6055 18.0976 26.5761 17.0703C25.8962 17.0369 25.4399 17.0158 24.9996 16.9929C23.8705 12.4336 21.2406 10.2736 17.7124 10.9631C14.2829 11.6333 12.1374 14.5884 12.6359 17.9516C13.078 20.9243 15.8876 23.3341 18.6601 23.0633V21.1178C15.6392 20.3386 14.2899 18.6341 14.7461 16.2243C15.1284 14.2049 17.0801 12.759 19.1322 12.9736C21.186 13.1882 22.7678 14.9332 22.7203 16.9859C22.2693 17.0105 21.8113 17.0334 21.1156 17.0703L21.1173 17.0721Z",
    fill: "url(#paint0_linear_1036_9200)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1036_9200",
    x: 0,
    y: 0,
    width: 38,
    height: 38,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1036_9200"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1036_9200",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1036_9200",
    x1: 19,
    y1: 7,
    x2: 19,
    y2: 27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE8888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0D98C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuestInfoReset);
export default __webpack_public_path__ + "static/media/guest_info_reset.639f6fac3354fd30953a3c049b93c98b.svg";
export { ForwardRef as ReactComponent };